import Vue from 'vue'
import ResourceService from './resource.service'
class NewReservationService extends ResourceService {
  static get resource() {
    return 'new-reservation'
  }

  static updateReserved(data) {
    const url = `${this.resource}/update-reserved`
    return new Promise((resolve, reject) => {
      Vue.axios
        .put(url, data)
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static downloadReservations(params) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`${this.resource}/download`, {
          responseType: 'blob',
          params,
        })
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static draftQuotation(data) {
    const url = `${this.resource}/draft-quotation`
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(url, data)
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static generatePl(data) {
    const url = `${this.resource}/post-so`
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(url, data)
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static reGeneratePl(reservationId) {
    const url = `${this.resource}/${reservationId}/regenerate-payment-link`
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(url)
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static newShiftReservation(data) {
    const url = `${this.resource}/shift-recurrence`
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(url, data)
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static updateShiftReserved(data) {
    const url = `${this.resource}/shift-recurrence`
    return new Promise((resolve, reject) => {
      Vue.axios
        .put(url, data)
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static shiftDraftQuotation(data) {
    const url = `${this.resource}/shift-draft-quotation`
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(url, data)
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static updateReservedRecurrence(data) {
    const url = `${this.resource}/update-reserved-recurrence`
    return new Promise((resolve, reject) => {
      Vue.axios
        .put(url, data)
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static updateReservedShiftRecurrence(data) {
    const url = `${this.resource}/update-reserved-shift-recurrence`
    return new Promise((resolve, reject) => {
      Vue.axios
        .put(url, data)
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

export default NewReservationService
